import { Add } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import { Alert, Avatar, CircularProgress, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { setTransportSelectedItem } from 'app/actions/map';
import { setSearchValue, setSelectedItem } from 'app/actions/trailer';
import { IconButton, InputSearch, Protect, Scrollbar } from 'app/components';
import { TrailerRoundedIcon } from 'app/icons';
import { TrailerDialog, TrailerForm, TrailerList } from 'app/pages/Trailer';
import { useAsyncAction, usePermission } from 'app/services';
import { transportLoad } from 'app/store/map';
import { trailerDelete, trailerLoad, trailerUpdate } from 'app/store/trailer';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
const Trailer = () => {
    var _a, _b;
    const formRef = useRef(null);
    const dispatch = useDispatch();
    const { items, selectedItem, searchValue } = useSelector((state) => state.trailer);
    const { transportSelectedItem, transportItems } = useSelector((state) => state.map);
    const [dialogOpen, setDialogOpen] = useState(false);
    const editPermission = usePermission(['create', 'update', 'delete']);
    const { asyncAction: fetchData, isLoading: isFetchLoading } = useAsyncAction(trailerLoad);
    const { asyncAction: updateSubmit, isLoading: isUpdateLoading, isSuccessful: isUpdateSuccessful, isError: isUpdateError, error: updateError, } = useAsyncAction(trailerUpdate, [selectedItem]);
    const { asyncAction: deleteSubmit, isLoading: isDeleteLoading, isSuccessful: isDeleteSuccessful, isError: isDeleteError, } = useAsyncAction(trailerDelete, [selectedItem]);
    const { asyncAction: fetchTransportData, isLoading: isFetchTransportSuccessful } = useAsyncAction(transportLoad);
    const handleDialogOpen = () => {
        setDialogOpen(true);
    };
    const handleDialogClose = () => {
        setDialogOpen(false);
    };
    const handleFormClick = () => {
        var _a;
        (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.handleFormSubmit();
    };
    const handleFormSubmit = (params) => {
        if (selectedItem) {
            updateSubmit(selectedItem.id, params);
        }
    };
    const handleDeleteClick = () => {
        if (selectedItem) {
            deleteSubmit(selectedItem.id);
        }
    };
    const handleTrailerSearchChange = (value) => dispatch(setSearchValue(value));
    useEffect(() => {
        if (isUpdateSuccessful) {
            fetchTransportData();
        }
    }, [isUpdateSuccessful]);
    useEffect(() => {
        if (isFetchTransportSuccessful && transportSelectedItem) {
            const updatedTransportItem = transportItems.find((item) => item.id === transportSelectedItem.id);
            dispatch(setTransportSelectedItem(updatedTransportItem));
        }
    }, [transportItems, transportSelectedItem]);
    useEffect(() => {
        fetchData();
        return () => {
            dispatch(setSelectedItem(null));
        };
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                width: '500px',
                height: '100%',
                zIndex: '1010',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                borderRight: '1px solid',
                borderColor: theme.palette.divider,
            }) },
            !isFetchLoading && (React.createElement(React.Fragment, null,
                React.createElement(Stack, { direction: 'row', alignItems: 'center', sx: (theme) => ({
                        padding: theme.spacing(2),
                        '.MuiButton-root.Mui-disabled': {
                            backgroundColor: 'background.default',
                            'svg path': {
                                fill: theme.palette.text.disabled,
                            },
                        },
                    }) },
                    React.createElement(InputSearch, { placeholder: '\u0413\u043E\u0441\u043D\u043E\u043C\u0435\u0440, VIN \u043D\u043E\u043C\u0435\u0440 \u0438\u043B\u0438 \u0434\u0430\u0442\u0447\u0438\u043A \u0443\u0440\u043E\u0432\u043D\u044F \u0442\u043E\u043F\u043B\u0438\u0432\u0430', value: searchValue, onChange: handleTrailerSearchChange }),
                    React.createElement(Protect, { permissions: ['create', 'update', 'delete'], renderPermitted: () => (React.createElement(React.Fragment, null,
                            React.createElement(IconButton, { onClick: handleDialogOpen, endIcon: React.createElement(Add, null) }),
                            React.createElement(TrailerDialog, { open: dialogOpen, onClose: handleDialogClose }))), renderForbidden: () => React.createElement(React.Fragment, null) })),
                items.length ? (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                        flex: '1 1 auto',
                        overflow: 'hidden',
                    } },
                    React.createElement(TrailerList, null))) : null)),
            !isFetchLoading && !items.length && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(Typography, { align: 'center', variant: 'body1', component: 'div' }, "\u0417\u0434\u0435\u0441\u044C \u043F\u043E\u043A\u0430 \u043D\u0438\u0447\u0435\u0433\u043E \u043D\u0435\u0442"),
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'div' }, "\u0412 \u044D\u0442\u043E\u043C \u0441\u043F\u0438\u0441\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0442\u044C\u0441\u044F \u043F\u0440\u0438\u0446\u0435\u043F\u044B"))),
            isFetchLoading && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: {
                    width: '100%',
                    height: '100%',
                } },
                React.createElement(CircularProgress, { size: 24 })))),
        React.createElement(Stack, { direction: 'column', sx: {
                height: '100%',
                flex: '1 1 auto',
            } },
            selectedItem && (React.createElement(Scrollbar, null,
                React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                        maxWidth: '540px',
                        margin: 'auto',
                        width: '100%',
                        padding: theme.spacing(2),
                    }) },
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            marginBottom: theme.spacing(3),
                            '.MuiAvatar-root': {
                                width: '56px',
                                height: '56px',
                                bgcolor: theme.palette.primary.main,
                            },
                            '.MuiAvatar-circular': {
                                color: theme.palette.primary.main,
                                bgcolor: alpha(theme.palette.primary.main, 0.12),
                                svg: {
                                    width: '30px',
                                    height: '30px',
                                },
                                path: {
                                    fill: theme.palette.primary.main,
                                },
                            },
                            '.MuiTypography-root:first-of-type': {
                                marginTop: theme.spacing(1),
                            },
                        }) },
                        React.createElement(Avatar, null,
                            React.createElement(TrailerRoundedIcon, { fontSize: 'large' })),
                        React.createElement(Typography, { variant: 'body1' }, selectedItem.number)),
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            width: '100%',
                            position: 'relative',
                            padding: theme.spacing(2),
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            form: {
                                width: '100%',
                            },
                        }) },
                        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                width: '100%',
                                paddingBottom: theme.spacing(1),
                                '.MuiTypography-h6': {
                                    fontSize: '15px',
                                },
                                '.MuiTypography-caption': {
                                    color: theme.palette.text.secondary,
                                },
                            }) },
                            React.createElement(Typography, { variant: 'h6' }, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F"),
                            React.createElement(Typography, { variant: 'caption' }, "\u041E\u0441\u043D\u043E\u0432\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043F\u0440\u0438\u0446\u0435\u043F\u0435")),
                        React.createElement("fieldset", { disabled: !editPermission, style: { border: 'none', margin: 0, padding: 0, width: '100%' } },
                            React.createElement(TrailerForm, { ref: formRef, defaultValues: selectedItem, onSubmit: handleFormSubmit })),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                '.MuiAlert-root': {
                                    width: '100%',
                                    marginTop: theme.spacing(2),
                                    borderRadius: theme.shape.borderRadius,
                                },
                            }) },
                            !isUpdateLoading && isUpdateError && (React.createElement(Alert, { severity: 'error' }, ((_a = updateError === null || updateError === void 0 ? void 0 : updateError.data) === null || _a === void 0 ? void 0 : _a.message) ||
                                ((_b = updateError === null || updateError === void 0 ? void 0 : updateError.data) === null || _b === void 0 ? void 0 : _b.error) ||
                                'Произошла ошибка при изменении данных. Попробуйте снова или обратитесь в техническую поддержку.')),
                            !isUpdateLoading && isUpdateSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
                        React.createElement(Protect, { permissions: ['create', 'update', 'delete'], renderPermitted: () => (React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                    width: '100%',
                                    paddingTop: theme.spacing(3),
                                }) },
                                React.createElement(LoadingButton, { variant: 'contained', loading: isUpdateLoading, onClick: handleFormClick, disableElevation: true }, "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F"))), renderForbidden: () => React.createElement(React.Fragment, null) })),
                    React.createElement(Stack, { direction: 'column', alignItems: 'center', sx: (theme) => ({
                            width: '100%',
                            display: 'none',
                            position: 'relative',
                            marginTop: theme.spacing(3),
                            padding: theme.spacing(2),
                            border: '1px solid',
                            borderRadius: theme.shape.borderRadius,
                            borderColor: theme.palette.divider,
                            bgcolor: 'background.paper',
                            '.MuiAlert-root': {
                                marginTop: theme.spacing(0),
                                marginBottom: theme.spacing(3),
                            },
                        }) },
                        React.createElement(Stack, { direction: 'column', sx: (theme) => ({
                                width: '100%',
                                paddingBottom: theme.spacing(3),
                                '.MuiTypography-h6': {
                                    fontSize: '15px',
                                },
                                '.MuiTypography-caption': {
                                    color: theme.palette.text.secondary,
                                },
                            }) },
                            React.createElement(Typography, { variant: 'h6' }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u0438\u0446\u0435\u043F"),
                            React.createElement(Typography, { variant: 'caption' }, "\u041C\u043E\u0436\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0439 \u043F\u0440\u0438\u0446\u0435\u043F, \u043D\u043E \u044D\u0442\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0435 \u043D\u0435\u043E\u0431\u0440\u0430\u0442\u0438\u043C\u043E. \u0412\u0441\u0435 \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u0435\u043D\u043D\u044B\u0435 \u0433\u0435\u043E\u0437\u043E\u043D\u044B \u0431\u0443\u0434\u0443\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u044B \u0438\u0437 \u0434\u0430\u043D\u043D\u043E\u0439 \u0433\u0440\u0443\u043F\u043F\u044B. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u0431\u0443\u0434\u044C\u0442\u0435 \u0443\u0432\u0435\u0440\u0435\u043D\u044B, \u0447\u0442\u043E \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C")),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                '.MuiAlert-root': {
                                    width: '100%',
                                    marginTop: theme.spacing(1),
                                    borderRadius: theme.shape.borderRadius,
                                },
                            }) },
                            isDeleteError && (React.createElement(Alert, { severity: 'error' }, "\u041F\u0440\u043E\u0438\u0437\u043E\u0448\u043B\u0430 \u043E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0443\u0434\u0430\u043B\u0435\u043D\u0438\u0438 \u0434\u0430\u043D\u043D\u044B\u0445. \u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u0442\u0435\u0445\u043D\u0438\u0447\u0435\u0441\u043A\u0443\u044E \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u043A\u0443.")),
                            isDeleteSuccessful && React.createElement(Alert, { severity: 'success' }, "\u0414\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043F\u0435\u0448\u043D\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")),
                        React.createElement(Stack, { direction: 'row', justifyContent: 'flex-end', sx: (theme) => ({
                                width: '100%',
                                paddingTop: theme.spacing(0),
                            }) },
                            React.createElement(LoadingButton, { color: 'error', variant: 'contained', loading: isDeleteLoading, disableElevation: true }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0440\u0438\u0446\u0435\u043F")))))),
            !selectedItem && (React.createElement(Stack, { direction: 'column', alignItems: 'center', justifyContent: 'center', sx: (theme) => ({
                    height: '100%',
                    padding: theme.spacing(0, 2),
                    '.MuiTypography-root': {
                        borderRadius: '20px',
                        marginTop: '24px',
                        padding: theme.spacing(0.5, 2),
                        bgcolor: alpha(theme.palette.grey.main, 0.12),
                    },
                }) },
                React.createElement(Typography, { align: 'center', color: 'text.secondary', variant: 'caption', component: 'label' }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u043F\u0440\u0438\u0446\u0435\u043F \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"))))));
};
export default Trailer;
